import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { ThemeContext } from 'styled-components';

import * as Styles from './index.styles';

const {
    StyledStepper,
    StyledStepsText,
    StyledActual,
    StyledNext,
    StyledCircle,
    StyledCircleMsg,
    StyledProgress,
    StyledSvg,
} = Styles;

const CIRCLE_RADIUS = 27;
const CIRCUMFERENCE = 2 * Math.PI * CIRCLE_RADIUS;

export const Stepper = ({ steps, currentIndex, justifyContent }) => {
    const [circleData, setCircleData] = useState({
        strokeDasharray: `${CIRCUMFERENCE} ${CIRCUMFERENCE}`,
        strokeDashoffset: `${CIRCUMFERENCE}`,
    });

    const theme = useContext(ThemeContext);

    const isFinalStep = () => currentIndex + 1 === steps.length;

    useEffect(() => {
        if (currentIndex !== null && currentIndex !== undefined) {
            const progressPercent = ((currentIndex + 1) * 100) / steps.length;
            const offset = CIRCUMFERENCE - (progressPercent / 100) * CIRCUMFERENCE;
            setCircleData(prev => ({
                ...prev,
                strokeDashoffset: offset,
            }));
        }
    }, [currentIndex]);

    return (
        <StyledStepper justifyContent={justifyContent}>
            <StyledStepsText isFinalStep={isFinalStep}>
                <StyledActual>{steps[currentIndex].name}</StyledActual>
                {!isFinalStep() && <StyledNext>Próximo: {steps[currentIndex + 1].name}</StyledNext>}
            </StyledStepsText>
            <StyledProgress>
                <StyledSvg height="66" width="66">
                    <StyledCircle
                        cx="33"
                        cy="33"
                        fill="transparent"
                        r={CIRCLE_RADIUS}
                        stroke={theme.components.stepper.circleStroke}
                        strokeWidth="3"
                        {...circleData}
                    />
                </StyledSvg>
                <StyledCircleMsg>{`${currentIndex + 1} de ${steps.length}`}</StyledCircleMsg>
            </StyledProgress>
        </StyledStepper>
    );
};

Stepper.propTypes = {
    steps: PropTypes.arrayOf(PropTypes.any).isRequired,
    currentIndex: PropTypes.number,
    justifyContent: PropTypes.string,
};

Stepper.defaultProps = {
    currentIndex: 0,
    justifyContent: '',
};

Stepper.Styles = Styles;
